import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
} from '@mui/material';

interface DeleteConfirmDialogProps {
  open: boolean;
  title: string;
  itemName: string;
  isPublic: boolean;
  onConfirm: (keepPublic: boolean) => void;
  onCancel: () => void;
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  title,
  itemName,
  isPublic,
  onConfirm,
  onCancel,
}) => {
  const [keepPublic, setKeepPublic] = useState(false);

  const handleConfirm = () => {
    onConfirm(keepPublic);
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          Êtes-vous sûr de vouloir supprimer "{itemName}" ?
        </Typography>
        
        {isPublic && (
          <Box mt={3}>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Cet élément est actuellement public. Que souhaitez-vous faire ?
              </FormLabel>
              <RadioGroup
                value={keepPublic ? 'keep' : 'private'}
                onChange={(e) => setKeepPublic(e.target.value === 'keep')}
              >
                <FormControlLabel 
                  value="private" 
                  control={<Radio />} 
                  label="Le rendre privé (ne sera plus visible par les autres)" 
                />
                <FormControlLabel 
                  value="keep" 
                  control={<Radio />} 
                  label="Le garder public (restera visible dans 'Ajouter existant')" 
                />
              </RadioGroup>
            </FormControl>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Annuler</Button>
        <Button onClick={handleConfirm} color="error" variant="contained">
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;